<template>
  <div id="main">
    <div class="main">
      <left-nav title="英语学习" navCode="6"></left-nav>
      <mid-swiper :adCode="59" :navList="englishMainNav"></mid-swiper>
      <right-form :consultList="consult"></right-form>
      <div style="clear: both"></div>
    </div>
    <div style="clear: both"></div>
  </div>
</template>

<script>
import LeftNav from '@/common-components/Channelleftnav'
import MidSwiper from '@/common-components/Channelmidswiper'
import { englishMainNav } from 'js/english/mainnav'
import RightForm from '@/common-components/Rightform'
import { consult } from 'js/english/consult.js'
export default {
  name: 'englishPage',
  data () {
    return {
      englishMainNav,
      consult
    }
  },
  components: {
    LeftNav,
    MidSwiper,
    RightForm
  }
}
</script>

<style scoped lang="stylus">
@import '~styles/varibles.styl'
#main
  width: 100%
  margin-bottom: 20px
  .main
    width: $defaultwidth
    margin: 0 auto
    position: relative
    min-height: 360px
  overflow hidden
</style>



// WEBPACK FOOTER //
// src/pages/english/components/swiper/Swiper.vue